import React, { Suspense, createContext } from 'react';
import { ConfigProvider } from 'antd';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from 'react-query';
import { GlobalStyle, ThemeProvider, globalAntTheme, theme } from '@/styles';
import { queryClient } from '@/configs';
import { Notification } from '@/components';
import { Spinner } from '../components/Spinner';

type MainProviderProps = {
  children: React.ReactNode;
};

const Context = createContext({});

export function MainProvider({ children }: MainProviderProps) {
  const { contextHolder } = Notification();

  return (
    <Suspense fallback={<Spinner />}>
      <GlobalStyle />
      <ConfigProvider theme={globalAntTheme}>
        <ThemeProvider theme={theme}>
          <Context.Provider value={{}}>
            <QueryClientProvider client={queryClient}>
              {contextHolder}
              <BrowserRouter>{children}</BrowserRouter>
            </QueryClientProvider>
          </Context.Provider>
        </ThemeProvider>
      </ConfigProvider>
    </Suspense>
  );
}
